// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../TypeUtils.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var GraphqlHelpers = require("../../GraphqlHelpers.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var CommonTypes_Geocode = require("../CommonTypes_Geocode.bs.js");
var CommonTypes_Business_Location_ParkingCost = require("./CommonTypes_Business_Location_ParkingCost.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var decode = include.decode;

var encode = include.encode;

var compare = include.compare;

var eq = include.eq;

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var Id_fromInt = include.fromInt;

var Id_fromString = include.fromString;

var Id_toInt = include.toInt;

var Id_toString = include.toString;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromInt: Id_fromInt,
  fromString: Id_fromString,
  toInt: Id_toInt,
  toString: Id_toString,
  decode: decode,
  encode: encode,
  compare: compare,
  eq: eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var Raw = {};

function parse$1(value) {
  var value$1 = value.geocode;
  var value$2 = value.parkingCost;
  var tmp;
  switch (value$2) {
    case "FEE_NOT_REIMBURSED" :
        tmp = "FEE_NOT_REIMBURSED";
        break;
    case "FEE_REIMBURSED" :
        tmp = "FEE_REIMBURSED";
        break;
    case "FREE" :
        tmp = "FREE";
        break;
    case "PARKING_INFO_NOT_PROVIDED" :
        tmp = "PARKING_INFO_NOT_PROVIDED";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$2
      };
  }
  var value$3 = value.parkingInstructions;
  return {
          address: value.address,
          geocode: !(value$1 == null) ? ({
                lat: GraphqlHelpers.Float.parse(value$1.lat),
                lng: GraphqlHelpers.Float.parse(value$1.lng)
              }) : undefined,
          id: parse(value.id),
          name: value.name,
          parkingCost: tmp,
          parkingInstructions: !(value$3 == null) ? value$3 : undefined
        };
}

function serialize(value) {
  var value$1 = value.parkingInstructions;
  var parkingInstructions = value$1 !== undefined ? value$1 : null;
  var value$2 = value.parkingCost;
  var parkingCost = typeof value$2 === "string" ? (
      value$2 === "FEE_REIMBURSED" ? "FEE_REIMBURSED" : (
          value$2 === "PARKING_INFO_NOT_PROVIDED" ? "PARKING_INFO_NOT_PROVIDED" : (
              value$2 === "FREE" ? "FREE" : "FEE_NOT_REIMBURSED"
            )
        )
    ) : value$2.VAL;
  var value$3 = value.name;
  var value$4 = value.id;
  var value$5 = Curry._1(encode, value$4);
  var value$6 = value.geocode;
  var geocode;
  if (value$6 !== undefined) {
    var value$7 = value$6.lng;
    var value$8 = GraphqlHelpers.Float.serialize(value$7);
    var value$9 = value$6.lat;
    var value$10 = GraphqlHelpers.Float.serialize(value$9);
    geocode = {
      lat: value$10,
      lng: value$8
    };
  } else {
    geocode = null;
  }
  var value$11 = value.address;
  return {
          address: value$11,
          geocode: geocode,
          id: value$5,
          name: value$3,
          parkingCost: parkingCost,
          parkingInstructions: parkingInstructions
        };
}

function verifyArgsAndParse(_CommonTypes_Business_Location, value) {
  return parse$1(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  return {
          address: param.address,
          geocode: Relude_Option.map((function (param) {
                  return CommonTypes_Geocode.make(param.lat, param.lng);
                }), param.geocode),
          id: param.id,
          name: param.name,
          parkingCost: CommonTypes_Business_Location_ParkingCost.parseApiResponse(param.parkingCost),
          parkingInstructions: Relude_Option.getOrElse("", param.parkingInstructions)
        };
}

function make(address, id, name) {
  return {
          address: address,
          geocode: undefined,
          id: id,
          name: name,
          parkingCost: /* NotProvided */3,
          parkingInstructions: ""
        };
}

function compare$1(param, param$1) {
  return Curry._2(compare, param.id, param$1.id);
}

function compareByName(param, param$1) {
  var other = Curry._2(Relude_String.compare, param.name, param$1.name);
  if (other === "equal_to") {
    return Curry._2(Relude_String.compare, param.address, param$1.address);
  } else {
    return other;
  }
}

function eq$1(param, param$1) {
  return Curry._2(eq, param.id, param$1.id);
}

var Ord = {
  eq: eq$1,
  compare: compare$1
};

var $$Map = Relude_Map.WithOrd(Ord);

var $$Set = Relude_Set.WithOrd(Ord);

function eq$2(param, param$1) {
  return Relude_Option.eqBy(eq$1, param, param$1);
}

function compare$2(param) {
  var a = param[0];
  if (a === undefined) {
    if (param[1] !== undefined) {
      return "less_than";
    } else {
      return "equal_to";
    }
  }
  var b = param[1];
  if (b !== undefined) {
    return compare$1(a, b);
  } else {
    return "greater_than";
  }
}

function compare$3(param, param$1) {
  return Relude_Function.curry2(compare$2, param, param$1);
}

var include$1 = Relude_Set.WithOrd({
      eq: eq$2,
      compare: compare$3
    });

var fromList = include$1.fromList;

var partial_arg = Relude_List.map(Relude_Option.pure);

function partial_arg$1(param) {
  return Relude_Globals.$great$great($$Set.toList, partial_arg, param);
}

function partial_arg$2(param) {
  return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                return Relude_List.prepend(undefined, param);
              }), param);
}

function fromSet(param) {
  return Relude_Globals.$great$great(partial_arg$2, fromList, param);
}

var SetWithNone_Comparable = include$1.Comparable;

var SetWithNone_empty = include$1.empty;

var SetWithNone_fromArray = include$1.fromArray;

var SetWithNone_isEmpty = include$1.isEmpty;

var SetWithNone_contains = include$1.contains;

var SetWithNone_add = include$1.add;

var SetWithNone_mergeMany = include$1.mergeMany;

var SetWithNone_remove = include$1.remove;

var SetWithNone_removeMany = include$1.removeMany;

var SetWithNone_update = include$1.update;

var SetWithNone_toggle = include$1.toggle;

var SetWithNone_union = include$1.union;

var SetWithNone_intersect = include$1.intersect;

var SetWithNone_diff = include$1.diff;

var SetWithNone_subset = include$1.subset;

var SetWithNone_compare = include$1.compare;

var SetWithNone_eq = include$1.eq;

var SetWithNone_forEach = include$1.forEach;

var SetWithNone_foldLeft = include$1.foldLeft;

var SetWithNone_foldRight = include$1.foldRight;

var SetWithNone_all = include$1.all;

var SetWithNone_any = include$1.any;

var SetWithNone_filter = include$1.filter;

var SetWithNone_keep = include$1.keep;

var SetWithNone_filterNot = include$1.filterNot;

var SetWithNone_reject = include$1.reject;

var SetWithNone_partition = include$1.partition;

var SetWithNone_length = include$1.length;

var SetWithNone_toArray = include$1.toArray;

var SetWithNone_toList = include$1.toList;

var SetWithNone_minimum = include$1.minimum;

var SetWithNone_maximum = include$1.maximum;

var SetWithNone_get = include$1.get;

var SetWithNone_getOrElse = include$1.getOrElse;

var SetWithNone_split = include$1.split;

var SetWithNone = {
  Comparable: SetWithNone_Comparable,
  empty: SetWithNone_empty,
  fromArray: SetWithNone_fromArray,
  fromList: fromList,
  isEmpty: SetWithNone_isEmpty,
  contains: SetWithNone_contains,
  add: SetWithNone_add,
  mergeMany: SetWithNone_mergeMany,
  remove: SetWithNone_remove,
  removeMany: SetWithNone_removeMany,
  update: SetWithNone_update,
  toggle: SetWithNone_toggle,
  union: SetWithNone_union,
  intersect: SetWithNone_intersect,
  diff: SetWithNone_diff,
  subset: SetWithNone_subset,
  compare: SetWithNone_compare,
  eq: SetWithNone_eq,
  forEach: SetWithNone_forEach,
  foldLeft: SetWithNone_foldLeft,
  foldRight: SetWithNone_foldRight,
  all: SetWithNone_all,
  any: SetWithNone_any,
  filter: SetWithNone_filter,
  keep: SetWithNone_keep,
  filterNot: SetWithNone_filterNot,
  reject: SetWithNone_reject,
  partition: SetWithNone_partition,
  length: SetWithNone_length,
  toArray: SetWithNone_toArray,
  toList: SetWithNone_toList,
  minimum: SetWithNone_minimum,
  maximum: SetWithNone_maximum,
  get: SetWithNone_get,
  getOrElse: SetWithNone_getOrElse,
  split: SetWithNone_split,
  fromSet: fromSet
};

function make$1(name, address) {
  return {
          name: name,
          address: address
        };
}

function makeFromExisting(param) {
  return {
          name: param.name,
          address: param.address
        };
}

var New = {
  make: make$1,
  makeFromExisting: makeFromExisting
};

var query = "fragment CommonTypes_Business_Location on BusinessLocation   {\naddress  \ngeocode  {\nlat  \nlng  \n}\n\nid  \nname  \nparkingCost  \nparkingInstructions  \n}\n";

exports.Id = Id;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$1;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.make = make;
exports.compare = compare$1;
exports.compareByName = compareByName;
exports.eq = eq$1;
exports.Ord = Ord;
exports.$$Map = $$Map;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.New = New;
/* include Not a pure module */
